// extracted by mini-css-extract-plugin
module.exports = {"mobileCategories":"CockpitLoggedContainer_mobileCategories__2mq8K"};